var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-toast-template", class: "base-toast--" + _vm.type },
    [
      _c("h3", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _vm.text
        ? _c("p", [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.action && _vm.actionLabel
        ? _c(
            "button",
            {
              staticClass: "base-toast-template__action",
              attrs: { type: "button" },
              on: { click: _vm.action },
            },
            [_vm._v(_vm._s(_vm.actionLabel))]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }